import axios from "axios";
import getAuthHeader from "./getAuthHeader";

const API_URL = window.config.managementServiceUrl;
const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    return {
      ...config,
      headers: {
        ...getAuthHeader(),
        "Content-Type": "application/json",
      },
    };
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = (error.config && error.config.url) || "";
    const status = error.response && error.response.status;
    // Only force re-login on real auth failures from management APIs.
    // Network/TLS errors must not wipe the session on refresh.
    if (
      status === 401 &&
      !String(url).includes("check") &&
      !String(url).includes("/auth/")
    ) {
      const token = localStorage.getItem("token");
      if (token) {
        // Soft-fail: keep token; let AuthService.checkAuth decide.
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

const { get, post, put, patch, delete: destroy } = apiClient;
export { get, post, put, patch, destroy };
